import React, { Component } from 'react';
import qs from 'qs';
import {
  load as loadAnnouncement,
  generate as generateDrafts,
  updateDraft,
  publishNews,
  publishWordPress,
  publishZendesk,
  publishFacebook,
  publishLinkedin,
  setImage as setAnnouncementImage,
  uploadImage as uploadAnnouncementImage,
  getImageUrl
} from '../services/announcementService';
import DraftCard from './DraftCard';
import ImageUploader from 'react-images-upload';
import {
  Box,
  Paper,
  Stack,
  Typography,
  Button,
  ToggleButtonGroup,
  ToggleButton,
  CircularProgress,
  Snackbar,
  Alert,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import TwitterIcon from '@mui/icons-material/Twitter';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import FacebookIcon from '@mui/icons-material/Facebook';
import WebIcon from '@mui/icons-material/Web';
import HelpCenterIcon from '@mui/icons-material/HelpCenter';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';

const CHANNELS = [
  { key: 'twitter', label: 'Twitter', icon: <TwitterIcon />, showCharCount: true, showHtmlPreview: false, publishLabel: null },
  { key: 'linkedin', label: 'LinkedIn', icon: <LinkedInIcon />, showCharCount: false, showHtmlPreview: false, publishLabel: 'Publier LinkedIn' },
  { key: 'facebook', label: 'Facebook', icon: <FacebookIcon />, showCharCount: false, showHtmlPreview: false, publishLabel: 'Publier Facebook' },
  { key: 'wordpress', label: 'Blog WordPress', icon: <WebIcon />, showCharCount: false, showHtmlPreview: true, publishLabel: 'Publier WP' },
  { key: 'zendesk', label: 'Zendesk Help Center', icon: <HelpCenterIcon />, showCharCount: false, showHtmlPreview: true, publishLabel: 'Publier Zendesk' },
  { key: 'news_inapp', label: 'News in-app', icon: <NotificationsActiveIcon />, showCharCount: false, showHtmlPreview: false, publishLabel: 'Publier News' }
];

const POLL_INTERVAL = 3000;
const POLL_TIMEOUT = 60000;

const PUBLISH_CONFIG = {
  wordpress: { fn: publishWordPress, msg: 'Article créé en brouillon dans WordPress !', urlKey: 'wordpress_edit_url' },
  zendesk: { fn: publishZendesk, msg: 'Article créé dans Zendesk Help Center !', urlKey: 'zendesk_url' },
  facebook: { fn: publishFacebook, msg: 'Post publié sur la Page Facebook !', urlKey: 'facebook_url' },
  linkedin: { fn: publishLinkedin, msg: 'Post publié sur la page LinkedIn Semiologic !', urlKey: 'linkedin_url' },
  news_inapp: { fn: publishNews, msg: 'News publiée avec succès !', urlKey: null },
};

class ReviewAnnouncement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      announcement: null,
      language: 'fr',
      isLoading: true,
      regenerating: false,
      confirmRegenOpen: false,
      confirmPublishOpen: false,
      confirmPublishLang: null,
      confirmPublishChannel: null,
      publishing: false,
      imageUploading: false,
      snackbar: { open: false, severity: 'success', message: '' }
    };
    this._isMounted = false;
    this._pollTimer = null;
    this._pollStart = null;
    this._pollErrors = 0;

    this.onLanguageChange = this.onLanguageChange.bind(this);
    this.handleRegenerate = this.handleRegenerate.bind(this);
    this.openConfirmRegen = this.openConfirmRegen.bind(this);
    this.closeConfirmRegen = this.closeConfirmRegen.bind(this);
    this.handleEditDraft = this.handleEditDraft.bind(this);
    this.handleCopyDraft = this.handleCopyDraft.bind(this);
    this.handlePublish = this.handlePublish.bind(this);
    this.openConfirmPublish = this.openConfirmPublish.bind(this);
    this.closeConfirmPublish = this.closeConfirmPublish.bind(this);
    this.closeSnackbar = this.closeSnackbar.bind(this);
    this.handleImageUpload = this.handleImageUpload.bind(this);
    this.handleImageRemove = this.handleImageRemove.bind(this);
  }

  async handleImageUpload(pictureFiles) {
    if (!pictureFiles || pictureFiles.length === 0) return;
    const id = this.getAnnouncementId();
    if (!id) return;
    const { language } = this.state;

    this.setState({ imageUploading: true });
    try {
      const res = await uploadAnnouncementImage(pictureFiles[0]);
      await setAnnouncementImage(id, language, res._id);
      if (!this._isMounted) return;
      this.setState({ snackbar: { open: true, severity: 'success', message: `Image ${language.toUpperCase()} mise à jour.` } });
      this.loadData();
    } catch (e) {
      if (!this._isMounted) return;
      this.setState({ snackbar: { open: true, severity: 'error', message: 'Erreur upload image.' } });
    } finally {
      if (this._isMounted) this.setState({ imageUploading: false });
    }
  }

  async handleImageRemove() {
    const id = this.getAnnouncementId();
    if (!id) return;
    const { language } = this.state;
    try {
      await setAnnouncementImage(id, language, null);
      if (!this._isMounted) return;
      this.setState({ snackbar: { open: true, severity: 'success', message: `Image ${language.toUpperCase()} retirée.` } });
      this.loadData();
    } catch (e) {
      if (!this._isMounted) return;
      this.setState({ snackbar: { open: true, severity: 'error', message: 'Erreur lors du retrait de l\'image.' } });
    }
  }

  componentDidMount() {
    this._isMounted = true;
    this.loadData();
  }

  componentWillUnmount() {
    this._isMounted = false;
    this.stopPolling();
  }

  getAnnouncementId() {
    const parsed = qs.parse(this.props.location.search, { ignoreQueryPrefix: true });
    return parsed.announcement_id || null;
  }

  async loadData() {
    const id = this.getAnnouncementId();
    if (!id) return;

    this.setState({ isLoading: true });
    try {
      const announcement = await loadAnnouncement(id);
      if (!this._isMounted) return;
      this.setState({ announcement, isLoading: false });

      if (announcement.status === 'generating') {
        this.startPolling();
      }
    } catch (e) {
      if (!this._isMounted) return;
      this.setState({
        isLoading: false,
        snackbar: { open: true, severity: 'error', message: 'Erreur lors du chargement.' }
      });
    }
  }

  startPolling() {
    this.stopPolling();
    this._pollStart = Date.now();
    this._pollErrors = 0;
    this._pollTimer = setInterval(() => {
      if (!this._isMounted) { this.stopPolling(); return; }
      if (Date.now() - this._pollStart > POLL_TIMEOUT) {
        this.stopPolling();
        this.setState({
          snackbar: { open: true, severity: 'warning', message: 'La génération prend trop de temps, réessayez.' }
        });
        return;
      }
      this.pollOnce();
    }, POLL_INTERVAL);
  }

  stopPolling() {
    if (this._pollTimer) {
      clearInterval(this._pollTimer);
      this._pollTimer = null;
    }
  }

  async pollOnce() {
    const id = this.getAnnouncementId();
    if (!id) return;
    try {
      const announcement = await loadAnnouncement(id);
      if (!this._isMounted) return;
      this._pollErrors = 0;
      this.setState({ announcement });
      if (announcement.status !== 'generating') {
        this.stopPolling();
      }
    } catch (e) {
      this._pollErrors++;
      if (this._pollErrors >= 3) {
        this.stopPolling();
        if (this._isMounted) {
          this.setState({
            snackbar: { open: true, severity: 'error', message: 'Erreur de connexion, veuillez rafraîchir la page.' }
          });
        }
      }
    }
  }

  onLanguageChange(e, newLang) {
    if (newLang) this.setState({ language: newLang });
  }

  openConfirmRegen() {
    this.setState({ confirmRegenOpen: true });
  }

  closeConfirmRegen() {
    this.setState({ confirmRegenOpen: false });
  }

  async handleRegenerate() {
    this.closeConfirmRegen();
    const id = this.getAnnouncementId();
    if (!id) return;

    this.setState({ regenerating: true });
    try {
      await generateDrafts(id);
      if (!this._isMounted) return;
      this.setState({ snackbar: { open: true, severity: 'success', message: 'Brouillons regénérés !' } });
      this.loadData();
    } catch (e) {
      if (!this._isMounted) return;
      this.setState({ snackbar: { open: true, severity: 'error', message: 'Erreur lors de la regénération.' } });
    } finally {
      if (this._isMounted) this.setState({ regenerating: false });
    }
  }

  async handleEditDraft(draftIndex, newContent, newTitle) {
    const id = this.getAnnouncementId();
    if (!id) return;

    try {
      await updateDraft(id, draftIndex, { content: newContent, title: newTitle, status: 'edited' });
      if (!this._isMounted) return;
      this.setState({ snackbar: { open: true, severity: 'success', message: 'Brouillon mis à jour.' } });
      this.loadData();
    } catch (e) {
      if (!this._isMounted) return;
      this.setState({ snackbar: { open: true, severity: 'error', message: 'Erreur lors de la mise à jour.' } });
    }
  }

  async handleCopyDraft(draftIndex) {
    const id = this.getAnnouncementId();
    if (!id) return;

    try {
      await updateDraft(id, draftIndex, { status: 'copied' });
      if (!this._isMounted) return;
      this.loadData();
    } catch (e) {
      // Ignore copy status update errors — the clipboard copy already succeeded
    }
  }

  openConfirmPublish(language, channel) {
    this.setState({ confirmPublishOpen: true, confirmPublishLang: language, confirmPublishChannel: channel });
  }

  closeConfirmPublish() {
    this.setState({ confirmPublishOpen: false, confirmPublishLang: null, confirmPublishChannel: null });
  }

  async handlePublish() {
    const { confirmPublishLang: language, confirmPublishChannel: channel } = this.state;
    this.closeConfirmPublish();
    const id = this.getAnnouncementId();
    if (!id || !language || !channel) return;

    const config = PUBLISH_CONFIG[channel] || PUBLISH_CONFIG.news_inapp;
    const publishFn = config.fn;
    const successMsg = config.msg;

    this.setState({ publishing: true });
    try {
      const result = await publishFn(id, language);
      if (!this._isMounted) return;

      const externalUrl = config.urlKey && result ? result[config.urlKey] : null;
      this.setState({ snackbar: { open: true, severity: 'success', message: successMsg, externalUrl } });
      this.loadData();
    } catch (e) {
      if (!this._isMounted) return;
      let msg = 'Erreur lors de la publication.';
      if (e && e.message) {
        if (e.message.includes('409')) msg = 'Ce brouillon a déjà été publié.';
        else if (e.message.includes('503')) msg = 'Service non configuré. Contactez l\'administrateur.';
        else if (e.message.includes('502')) msg = 'Erreur du service externe. Réessayez.';
      }
      this.setState({ snackbar: { open: true, severity: 'error', message: msg } });
    } finally {
      if (this._isMounted) this.setState({ publishing: false });
    }
  }

  closeSnackbar() {
    this.setState((prev) => ({ snackbar: { ...prev.snackbar, open: false, externalUrl: null } }));
  }

  getDraftsForLanguage() {
    const { announcement, language } = this.state;
    if (!announcement || !announcement.drafts) return [];
    return announcement.drafts
      .map((draft, index) => ({ ...draft, _originalIndex: index }))
      .filter((d) => d.language === language);
  }

  render() {
    const { announcement, language, isLoading, regenerating, confirmRegenOpen, snackbar, imageUploading } = this.state;
    const id = this.getAnnouncementId();
    const draftsForLang = this.getDraftsForLanguage();

    if (isLoading) {
      return (
        <Box sx={{ p: 4, textAlign: 'center' }}>
          <CircularProgress />
        </Box>
      );
    }

    if (!announcement) {
      return (
        <Box sx={{ p: 2 }}>
          <Typography color="error">Annonce introuvable.</Typography>
        </Box>
      );
    }

    const hasDrafts = announcement.drafts && announcement.drafts.length > 0;
    const isGenerating = announcement.status === 'generating';
    const currentImageId = (announcement.images && announcement.images[language]) || announcement.image || null;
    const currentImageUrl = currentImageId ? getImageUrl(currentImageId) : null;

    return (
      <Box sx={{ p: 2 }}>
        <Paper variant="outlined" sx={{ p: 3, maxWidth: 900, mx: 'auto' }}>
          <Stack spacing={3}>
            {/* Header */}
            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems={{ xs: 'stretch', sm: 'center' }} justifyContent="space-between">
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Button
                  component={RouterLink}
                  to={`/super-admin/FormAnnouncement?announcement_id=${id}`}
                  startIcon={<ArrowBackIcon />}
                  size="small"
                >
                  Retour
                </Button>
                <Typography variant="h6" sx={{ ml: 1 }}>{announcement.title}</Typography>
              </Box>
              <Button
                variant="outlined"
                color="secondary"
                onClick={this.openConfirmRegen}
                disabled={regenerating || isGenerating}
                startIcon={regenerating ? <CircularProgress size={18} /> : null}
              >
                {regenerating ? 'Regénération...' : 'Regénérer tout'}
              </Button>
            </Stack>

            {/* Generating state */}
            {isGenerating && (
              <Box sx={{ textAlign: 'center', py: 4 }}>
                <CircularProgress sx={{ mb: 2 }} />
                <Typography color="text.secondary">Génération en cours... Veuillez patienter.</Typography>
              </Box>
            )}

            {/* No drafts */}
            {!isGenerating && !hasDrafts && (
              <Box sx={{ textAlign: 'center', py: 4 }}>
                <Typography color="text.secondary">
                  Aucun brouillon. Retournez au formulaire pour générer.
                </Typography>
                <Button
                  component={RouterLink}
                  to={`/super-admin/FormAnnouncement?announcement_id=${id}`}
                  variant="contained"
                  sx={{ mt: 2 }}
                >
                  Aller au formulaire
                </Button>
              </Box>
            )}

            {/* Draft cards */}
            {!isGenerating && hasDrafts && (
              <>
                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                  <ToggleButtonGroup
                    value={language}
                    exclusive
                    onChange={this.onLanguageChange}
                    size="small"
                  >
                    <ToggleButton value="fr">FR</ToggleButton>
                    <ToggleButton value="en">EN</ToggleButton>
                  </ToggleButtonGroup>
                </Box>

                {/* Per-language illustration image — applied to every channel of this language */}
                <Box sx={{ textAlign: 'center', borderBottom: '1px solid', borderColor: 'divider', pb: 2 }}>
                  <Typography variant="subtitle2" sx={{ mb: 1 }}>
                    Image {language.toUpperCase()} (illustration, optionnelle — utilisée sur tous les canaux)
                  </Typography>
                  {currentImageUrl && (
                    <Box sx={{ mb: 1 }}>
                      <img
                        src={currentImageUrl}
                        alt={`illustration ${language}`}
                        style={{ maxWidth: '100%', maxHeight: 160, borderRadius: 4 }}
                      />
                      <Box>
                        <Button size="small" color="error" onClick={this.handleImageRemove} disabled={imageUploading}>
                          Retirer l'image {language.toUpperCase()}
                        </Button>
                      </Box>
                    </Box>
                  )}
                  <ImageUploader
                    key={language}
                    withIcon={false}
                    singleImage={true}
                    withPreview={false}
                    maxFileSize={2097152}
                    label="Max: 2mb, formats: jpg / png / gif"
                    buttonText={currentImageUrl ? `Remplacer l'image ${language.toUpperCase()}` : `Ajouter une image ${language.toUpperCase()}`}
                    onChange={this.handleImageUpload}
                    imgExtension={['.jpg', '.gif', '.png']}
                  />
                </Box>

                {CHANNELS.map((channel) => {
                  const draft = draftsForLang.find((d) => d.channel === channel.key);
                  if (!draft) return null;
                  return (
                    <DraftCard
                      key={channel.key}
                      draft={draft}
                      channelLabel={channel.label}
                      channelIcon={channel.icon}
                      imageUrl={currentImageUrl}
                      showCharCount={channel.showCharCount}
                      showHtmlPreview={channel.showHtmlPreview}
                      publishLabel={draft.status === 'published' && channel.publishLabel ? 'Déjà publié' : channel.publishLabel}
                      publishEnabled={(channel.key === 'news_inapp' || channel.key === 'wordpress' || channel.key === 'zendesk' || channel.key === 'facebook' || channel.key === 'linkedin') && draft.status !== 'published'}
                      onEdit={(content, title) => this.handleEditDraft(draft._originalIndex, content, title)}
                      onCopy={() => this.handleCopyDraft(draft._originalIndex)}
                      onPublish={() => this.openConfirmPublish(draft.language, channel.key)}
                    />
                  );
                })}
              </>
            )}
          </Stack>
        </Paper>

        {/* Confirm regeneration dialog */}
        <Dialog open={confirmRegenOpen} onClose={this.closeConfirmRegen}>
          <DialogTitle>Regénérer les brouillons ?</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Cela écrasera tous les brouillons actuels (y compris ceux édités). Continuer ?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.closeConfirmRegen}>Annuler</Button>
            <Button onClick={this.handleRegenerate} color="error" variant="contained">Regénérer</Button>
          </DialogActions>
        </Dialog>

        {/* Confirm publish dialog */}
        <Dialog open={this.state.confirmPublishOpen} onClose={this.closeConfirmPublish}>
          <DialogTitle>
            {{ wordpress: 'Créer un brouillon WordPress', zendesk: 'Créer un article Zendesk', facebook: 'Publier sur Facebook', linkedin: 'Publier sur LinkedIn', news_inapp: 'Publier la News' }[this.state.confirmPublishChannel] || 'Publier'}
            {' '}[{this.state.confirmPublishLang ? this.state.confirmPublishLang.toUpperCase() : ''}] ?
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              {{ wordpress: 'Un article brouillon sera créé dans WordPress. Vous pourrez le relire et publier depuis l\'éditeur WP.',
                 zendesk: 'Un article brouillon sera créé dans Zendesk Help Center. Vous pourrez le relire et publier depuis Zendesk.',
                 facebook: 'Le post va être publié publiquement et immédiatement sur la Page Facebook Graphcomment. Continuer ?',
                 linkedin: 'Le post va être publié publiquement et immédiatement sur la page entreprise LinkedIn Semiologic. Continuer ?',
                 news_inapp: 'La News sera immédiatement visible par tous les utilisateurs concernés. Continuer ?'
              }[this.state.confirmPublishChannel] || 'Continuer ?'}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.closeConfirmPublish}>Annuler</Button>
            <Button onClick={this.handlePublish} color="primary" variant="contained" disabled={this.state.publishing}>
              {this.state.publishing ? 'Publication...' : (
                { wordpress: 'Créer le brouillon', zendesk: 'Créer l\'article', facebook: 'Publier sur Facebook', linkedin: 'Publier sur LinkedIn', news_inapp: 'Publier' }[this.state.confirmPublishChannel] || 'Publier'
              )}
            </Button>
          </DialogActions>
        </Dialog>

        <Snackbar
          open={snackbar.open}
          autoHideDuration={snackbar.externalUrl ? null : 3000}
          onClose={this.closeSnackbar}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        >
          <Alert
            onClose={this.closeSnackbar}
            severity={snackbar.severity}
            sx={{ width: '100%' }}
            action={snackbar.externalUrl ? (
              <Button color="inherit" size="small" href={snackbar.externalUrl} target="_blank" rel="noopener">
                Ouvrir
              </Button>
            ) : undefined}
          >
            {snackbar.message}
          </Alert>
        </Snackbar>
      </Box>
    );
  }
}

export default ReviewAnnouncement;
